import { render } from "./IconBankNote.vue.js?vue&type=template&id=439ef567!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconBankNote.vue?vue&type=template&id=439ef567"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__